import { useSession } from "@d12labs/auth/client";
import { apiFetch } from "@d12labs/client";
import { useQuery } from "@tanstack/react-query";

/**
 * Resolves the current user's avatar to a fresh presigned URL.
 * Refetches when user.image changes; presigned URLs are 15min so cache
 * for 10min before transparent refresh.
 *
 * Returns `null` when the user has no avatar set or is signed out.
 */
export function useAvatarUrl(): { url: string | null; isLoading: boolean } {
	const { data } = useSession();
	const image = data?.user?.image ?? null;
	const query = useQuery({
		queryKey: ["account", "avatar-url", image],
		queryFn: () => apiFetch<{ url: string | null }>("/api/account/avatar/url").then((r) => r.url),
		enabled: !!image,
		staleTime: 10 * 60 * 1000,
	});
	return { url: image ? (query.data ?? null) : null, isLoading: query.isLoading };
}
